<template>
  <v-card-text>
  <v-card class="orange darken-3 rounded-xl" dark>
    <v-card-text class="pt-4">
        <v-row no-gutters>
          <v-col
            cols="12"
            sm="6"
          >
            <v-col
              cols="12"
              sm="6"
            >
              <v-radio-group
                v-model="customerType"
                mandatory
              >
                <v-radio
                  label="Visitor"
                  value="visitor"
                  :ripple="rippleEffect"
                  dark
                />
                <v-radio
                  label="Contractor"
                  value="contractor"
                  :ripple="rippleEffect"
                  dark
                />
                <v-radio
                  label="Staff"
                  value="staff"
                  :ripple="rippleEffect"
                  dark
                />
              </v-radio-group>
            </v-col>
          </v-col>
        </v-row>
    </v-card-text>
  </v-card>
  <v-card-actions>
      <v-btn color="orange darken-3" x-large block dark
        class="rounded-xl mt-8"
        @click.prevent="onFormSubmit()"
        >
          Next
      </v-btn>
    </v-card-actions>
  </v-card-text>
</template>
<script>

export default {
  name: 'UserType',
  data: () => ({
    customerType: 'visitor',
    loading: false,
    rippleEffect: true
  }),

  created () {
    this.$store.dispatch('decision/onCustomerDecision', this.customerType)
  },

  methods: {
    onFormSubmit () {
      this.$store.dispatch('decision/onCustomerDecision', this.customerType)

      this.$emit('stepSuccess')
    }
  }
}
</script>
